import React from "react"

import { ArrowBack } from "../icons/arrow-back"
import { Rotating } from "../icons/rotating"

export function BackButton({
  className,
  onClick,
  isLoading = false,
  isNew,
}: {
  className?: string
  onClick?: () => void
  isNew?: boolean
  isLoading?: boolean
}) {
  return isNew ? (
    <div className="ml-2.5 mt-[0.6rem] flex items-center font-bold uppercase text-light-blue" onClick={onClick}>
      <ArrowBack w={32} h={32} className="mr-2" />
      back
    </div>
  ) : (
    <div className={className}>
      <div className="relative h-[4.2rem] w-[10.4rem] overflow-hidden lg:mr-[3.4rem] lg:w-[7rem]">
        <div className="absolute bottom-0 left-0 right-0 top-[-0.3rem] bg-[url(/images/shared/game/back-button/back_button_bg.svg)] bg-no-repeat lg:bg-none" />
        <div className="absolute bottom-[0.6rem] left-0 right-[50%] top-0 bg-gradient-to-r from-[#FF64B833] to-[#FF64B800] lg:bg-none" />
        <div
          onClick={onClick}
          className="absolute bottom-[0.7rem] left-0 right-[2rem] top-0 flex cursor-pointer items-center justify-center text-[0.8rem] font-bold uppercase text-[#9188E2]"
        >
          {isLoading ? (
            <Rotating className="w-[1.5rem] animate-spin" />
          ) : (
            <>
              <ArrowBack h="2.5rem" className="mr-2" /> back
            </>
          )}
        </div>
      </div>
    </div>
  )
}
